const paletteNames = {
  pt: {
    anime: [
      "Sakura",
      "Galáxia",
      "Floresta encantada",
      "Romance vintage",
      "Cinza monocromático",
      "Oceano profundo",
      "Sépia vintage",
      "Fogo",
      "Floral",
      "Retrô neon",
      "Romance gótico",
      "Sonhos doces",
      "Quente e ousada",
      "Minimalismo acolhedor",
      "Estilo náutico",
      "Doce e picante",
      "Glamour retrô",
      "Calor do verão",
      "Tons terracota",
      "Simples e elegante",
    ],
    dining: [
      "Charme rústico",
      "Dias ensolarados",
      "Vinho tinto",
      "Refúgio na floresta",
      "Brisa do mar",
      "Festa apimentada",
      "Paixão intensa",
      "Colheita dourada",
      "Névoa roxa",
      "Sonhos de lavanda",
      "Rosa romântica",
      "Industrial sofisticado",
      "Cana-de-açúcar",
      "Verdes frescos",
      "Charme vintage",
    ],
    notes: [
      "Folhas de outono",
      "Candy crush",
      "Brisa do mar",
      "Diversão de verão",
      "Flor de cerejeira",
      "Frescor de menta",
      "Era dourada",
      "Cinza ardósia",
      "Névoa roxa",
      "Campos de lavanda",
      "Chá verde",
      "Alerta vermelho",
      "Preto e branco",
      "Tons de cobre",
      "Sorvete de framboesa",
      "Pêssego suave",
    ],
    bedroom: [
      "Zen minimalista",
      "Preto, branco e dourado",
      "Tons quentes",
      "Tons de rosa",
      "Azuis acolhedores",
      "Laranja quente",
      "Frescor de menta",
      "Marinho e amarelo",
      "Tons terrosos modernos",
      "Romântico e dramático",
      "Neutros modernos",
      "Clássico moderno",
      "Tons de joia modernos",
      "Terra e vermelho",
      "Minimalismo moderno",
    ],
    instagram: [
      "Verão tropical",
      "Vibrante e jovem",
      "Minimalista elegante",
      "Natureza serena",
      "Tons quentes",
      "Praia tranquila",
      "Primavera fresca",
      "Outono acolhedor",
      "Inverno elegante",
      "Romance delicado",
      "Moda urbana",
      "Retrô vintage",
      "Esportiva energética",
      "Tecnológica futurista",
      "Arco-íris alegre",
      "Monocromática elegante",
      "Praia ensolarada",
      "Natureza serena",
    ],
    slides: [
      "Paleta de outono",
      "Paleta minimalista",
      "Paleta vibrante",
      "Paleta descontraída",
      "Paleta profissional",
      "Paleta tecnológica",
      "Paleta de verão",
      "Paleta elegante",
      "Paleta pastel",
      "Paleta criativa",
      "Paleta retrô",
      "Paleta de contraste",
      "Paleta relaxante",
      "Paleta minimalista",
      "Paleta jovem",
      "Paleta profissional",
    ],
    weddings: [
      "Romance atemporal",
      "Jardim silvestre",
      "Areia e linho",
      "Rosa profundo",
      "Azul editorial",
      "Dourado acolhedor",
      "Pôr do sol coral",
      "Lavanda noturna",
      "Minimalismo botânico",
      "Terracota festiva",
    ],
    cafes: [
      "Café especial",
      "Verde botânico",
      "Padaria coral",
      "Industrial limpo",
      "Sol da manhã",
      "Torra vintage",
      "Azul tranquilo",
      "Rosa editorial",
      "Oliva e cerâmica",
      "Especiarias e cacau",
    ],
    personal: [
      "Acolhedora e especialista",
      "Confiança azul",
      "Otimismo criativo",
      "Minimalista editorial",
      "Verde consciente",
      "Rosa com personalidade",
      "Índigo estratégico",
      "Artesanato terracota",
      "Turquesa clara",
      "Luxo tranquilo",
    ],
  },
  fr: {
    anime: [
      "Sakura",
      "Galaxie",
      "Forêt enchantée",
      "Romance vintage",
      "Gris monochrome",
      "Océan profond",
      "Sépia vintage",
      "Feu",
      "Floral",
      "Néon rétro",
      "Romance gothique",
      "Doux rêves",
      "Chaleureux et audacieux",
      "Minimalisme chaleureux",
      "Style nautique",
      "Doux et épicé",
      "Glamour rétro",
      "Chaleur estivale",
      "Tons terracotta",
      "Simple et élégant",
    ],
    dining: [
      "Charme rustique",
      "Jours ensoleillés",
      "Vin rouge",
      "Refuge forestier",
      "Brise marine",
      "Fête épicée",
      "Passion intense",
      "Récolte dorée",
      "Brume violette",
      "Rêves de lavande",
      "Rose romantique",
      "Industriel chic",
      "Sucre d'orge",
      "Verts frais",
      "Charme vintage",
    ],
    notes: [
      "Feuilles d'automne",
      "Candy crush",
      "Brise marine",
      "Joie estivale",
      "Fleur de cerisier",
      "Fraîcheur menthe",
      "Âge d'or",
      "Gris ardoise",
      "Brume violette",
      "Champs de lavande",
      "Thé vert",
      "Alerte rouge",
      "Noir et blanc",
      "Tons cuivre",
      "Sorbet framboise",
      "Pêche tendre",
    ],
    bedroom: [
      "Zen minimaliste",
      "Noir, blanc et or",
      "Tons chaleureux",
      "Nuances de rose",
      "Bleus douillets",
      "Orange chaleureux",
      "Fraîcheur menthe",
      "Marine et jaune",
      "Terres modernes",
      "Romantique et dramatique",
      "Neutres modernes",
      "Classique moderne",
      "Tons précieux modernes",
      "Terre et rouge",
      "Minimalisme moderne",
    ],
    instagram: [
      "Été tropical",
      "Vibrant et jeune",
      "Minimaliste élégant",
      "Nature sereine",
      "Tons chaleureux",
      "Plage apaisée",
      "Printemps frais",
      "Automne chaleureux",
      "Hiver élégant",
      "Romance délicate",
      "Mode urbaine",
      "Rétro vintage",
      "Sportive énergique",
      "Technologique futuriste",
      "Arc-en-ciel joyeux",
      "Monochrome élégant",
      "Plage estivale",
      "Nature sereine",
    ],
    slides: [
      "Palette automnale",
      "Palette minimaliste",
      "Palette vibrante",
      "Palette ludique",
      "Palette professionnelle",
      "Palette technologique",
      "Palette estivale",
      "Palette élégante",
      "Palette pastel",
      "Palette créative",
      "Palette rétro",
      "Palette contrastée",
      "Palette apaisante",
      "Palette minimaliste",
      "Palette jeune",
      "Palette professionnelle",
    ],
    weddings: [
      "Romance intemporelle",
      "Jardin sauvage",
      "Sable et lin",
      "Rose profond",
      "Bleu éditorial",
      "Or chaleureux",
      "Coucher de soleil corail",
      "Lavande nocturne",
      "Minimalisme botanique",
      "Terracotta festive",
    ],
    cafes: [
      "Café de spécialité",
      "Vert botanique",
      "Boulangerie corail",
      "Industriel épuré",
      "Soleil matinal",
      "Torréfaction vintage",
      "Bleu paisible",
      "Rose éditorial",
      "Olive et céramique",
      "Épices et cacao",
    ],
    personal: [
      "Chaleureuse et experte",
      "Confiance bleue",
      "Optimisme créatif",
      "Minimaliste éditorial",
      "Vert conscient",
      "Rose affirmé",
      "Indigo stratégique",
      "Artisanat terracotta",
      "Turquoise claire",
      "Luxe discret",
    ],
  },
  de: {
    anime: [
      "Sakura",
      "Galaxie",
      "Zauberwald",
      "Vintage-Romantik",
      "Monochromes Grau",
      "Tiefer Ozean",
      "Vintage-Sepia",
      "Feuer",
      "Blüten",
      "Retro-Neon",
      "Gothic-Romantik",
      "Süße Träume",
      "Warm und mutig",
      "Warmes Minimal",
      "Nautischer Stil",
      "Süß und würzig",
      "Retro-Glamour",
      "Sommerwärme",
      "Terrakotta-Töne",
      "Schlicht und elegant",
    ],
    dining: [
      "Rustikaler Charme",
      "Sonnige Tage",
      "Rotwein",
      "Waldrefugium",
      "Meeresbrise",
      "Würzige Fiesta",
      "Intensive Leidenschaft",
      "Goldene Ernte",
      "Violetter Dunst",
      "Lavendelträume",
      "Romantische Rose",
      "Industrial Chic",
      "Zuckerstange",
      "Frische Grüntöne",
      "Vintage-Charme",
    ],
    notes: [
      "Herbstblätter",
      "Candy Crush",
      "Meeresbrise",
      "Sommerlaune",
      "Kirschblüte",
      "Minzfrische",
      "Goldenes Zeitalter",
      "Schiefergrau",
      "Violetter Dunst",
      "Lavendelfelder",
      "Grüner Tee",
      "Rotalarm",
      "Schwarz und Weiß",
      "Kupfertöne",
      "Himbeersorbet",
      "Sanfter Pfirsich",
    ],
    bedroom: [
      "Minimalistisches Zen",
      "Schwarz, Weiß und Gold",
      "Warme Töne",
      "Rosatöne",
      "Behagliche Blautöne",
      "Warmes Orange",
      "Minzfrische",
      "Marineblau und Gelb",
      "Moderne Erdtöne",
      "Romantisch und dramatisch",
      "Moderne Neutraltöne",
      "Moderner Klassiker",
      "Moderne Juwelentöne",
      "Erde und Rot",
      "Modernes Minimal",
    ],
    instagram: [
      "Tropischer Sommer",
      "Jung und lebendig",
      "Elegantes Minimal",
      "Ruhige Natur",
      "Warme Töne",
      "Entspannter Strand",
      "Frischer Frühling",
      "Warmer Herbst",
      "Eleganter Winter",
      "Zarte Romantik",
      "Urbane Mode",
      "Vintage-Retro",
      "Sportliche Energie",
      "Futuristische Technik",
      "Fröhlicher Regenbogen",
      "Elegantes Monochrom",
      "Sommerstrand",
      "Ruhige Natur",
    ],
    slides: [
      "Herbstpalette",
      "Minimalistische Palette",
      "Lebendige Palette",
      "Verspielte Palette",
      "Professionelle Palette",
      "Technologische Palette",
      "Sommerpalette",
      "Elegante Palette",
      "Pastellpalette",
      "Kreative Palette",
      "Retro-Palette",
      "Kontrastpalette",
      "Beruhigende Palette",
      "Minimalistische Palette",
      "Jugendliche Palette",
      "Professionelle Palette",
    ],
    weddings: [
      "Zeitlose Romantik",
      "Wilder Garten",
      "Sand und Leinen",
      "Tiefes Rosa",
      "Editorial-Blau",
      "Warmes Gold",
      "Korallen-Sonnenuntergang",
      "Nachtlavendel",
      "Botanischer Minimalismus",
      "Festliches Terrakotta",
    ],
    cafes: [
      "Specialty Coffee",
      "Botanisches Grün",
      "Korallen-Bäckerei",
      "Klarer Industrial-Stil",
      "Morgensonne",
      "Vintage-Röstung",
      "Ruhiges Blau",
      "Editorial-Rosa",
      "Olive und Keramik",
      "Gewürze und Kakao",
    ],
    personal: [
      "Warm und kompetent",
      "Blaues Vertrauen",
      "Kreativer Optimismus",
      "Editoriales Minimal",
      "Bewusstes Grün",
      "Rosa mit Charakter",
      "Strategisches Indigo",
      "Terrakotta-Handwerk",
      "Helles Türkis",
      "Ruhiger Luxus",
    ],
  },
};

const descriptionTemplates = {
  pt: {
    anime: name =>
      `Uma combinação inspirada em ${name.toLowerCase()}, ideal para personagens, cenários e projetos de anime.`,
    dining: name =>
      `${name} cria uma atmosfera acolhedora para refeições, conversas e momentos compartilhados.`,
    notes: name =>
      `${name} ajuda a organizar títulos, conceitos e destaques sem perder a legibilidade dos seus apontamentos.`,
    bedroom: name =>
      `${name} combina conforto e personalidade para criar um quarto de casal moderno e acolhedor.`,
    instagram: name =>
      `${name} dá ao seu feed uma direção visual consistente para posts, stories e capas de reels.`,
    slides: name =>
      `${name} cria uma hierarquia clara para títulos, dados e mensagens importantes em apresentações.`,
    weddings: name =>
      `${name} traduz uma celebração com personalidade em convites, flores, mesas e detalhes digitais.`,
    cafes: name =>
      `${name} conecta fachada, cardápio, balcão e redes sociais em uma experiência de cafeteria coerente.`,
    personal: name =>
      `${name} transforma sua personalidade profissional em uma identidade visual reconhecível e flexível.`,
  },
  fr: {
    anime: name =>
      `Une combinaison inspirée par ${name.toLowerCase()}, idéale pour les personnages, les décors et les projets d'anime.`,
    dining: name =>
      `${name} crée une atmosphère accueillante pour les repas, les conversations et les moments partagés.`,
    notes: name =>
      `${name} aide à organiser titres, notions et points importants tout en gardant vos notes lisibles.`,
    bedroom: name =>
      `${name} associe confort et personnalité pour créer une chambre parentale moderne et chaleureuse.`,
    instagram: name =>
      `${name} donne à votre feed une direction visuelle cohérente pour les posts, stories et couvertures de reels.`,
    slides: name =>
      `${name} crée une hiérarchie claire pour les titres, les données et les messages importants des présentations.`,
    weddings: name =>
      `${name} traduit une célébration personnelle dans les invitations, les fleurs, les tables et les contenus numériques.`,
    cafes: name =>
      `${name} relie façade, carte, comptoir et réseaux sociaux dans une expérience de café cohérente.`,
    personal: name =>
      `${name} transforme votre personnalité professionnelle en une identité visuelle reconnaissable et flexible.`,
  },
  de: {
    anime: name =>
      `Eine von ${name.toLowerCase()} inspirierte Kombination für Figuren, Hintergründe und Anime-Projekte.`,
    dining: name =>
      `${name} schafft eine einladende Atmosphäre für Mahlzeiten, Gespräche und gemeinsame Momente.`,
    notes: name =>
      `${name} ordnet Überschriften, Begriffe und Highlights, ohne die Lesbarkeit deiner Notizen zu verlieren.`,
    bedroom: name =>
      `${name} verbindet Komfort und Persönlichkeit für ein modernes, behagliches Schlafzimmer für Paare.`,
    instagram: name =>
      `${name} gibt deinem Feed eine klare visuelle Richtung für Posts, Stories und Reel-Cover.`,
    slides: name =>
      `${name} schafft eine klare Hierarchie für Titel, Daten und wichtige Aussagen in Präsentationen.`,
    weddings: name =>
      `${name} übersetzt eine persönliche Feier in Einladungen, Blumen, Tische und digitale Details.`,
    cafes: name =>
      `${name} verbindet Fassade, Karte, Tresen und Social Media zu einem stimmigen Café-Erlebnis.`,
    personal: name =>
      `${name} macht deine berufliche Persönlichkeit als flexible, wiedererkennbare visuelle Identität sichtbar.`,
  },
};

export function localizeTematicPalettes(palettes, topic, locale) {
  if (locale === "es") {
    return palettes;
  }

  const names = paletteNames[locale]?.[topic] || [];
  const createDescription = descriptionTemplates[locale]?.[topic];

  return palettes.map((item, index) => {
    const localizedName = names[index] || item.paletteName;

    return {
      ...item,
      paletteName: localizedName,
      paletteDescription: createDescription
        ? createDescription(localizedName)
        : item.paletteDescription,
    };
  });
}
